import { decode } from 'base64-arraybuffer';

export function base64toFile(content: string, name: string) {
  return new File([new Blob([decode(content)])], name);
}
